<div id="aqar" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">AQAR — Annual Quality Assurance Report</h2>
    <p class="inner-lead mt-3">
      The Annual Quality Assurance Report (AQAR) is submitted by the IQAC of Shah Satnam Ji Girls' College, Sirsa to
      NAAC every year. It documents the quality initiatives undertaken and progress made by the institution during the
      academic year.
    </p>
    <hr class="divider">
    <h4 class="section-subtitle">AQAR Reports</h4>
    <!-- NOTE: Upload AQAR PDFs to src/assets/pdf/iqac/ -->
    <ul class="download-list mt-3">
      <li class="download-item">
        <span class="download-item-label">AQAR 2023–24</span>
        <span class="download-item-meta">2023-24</span>
        <a href="/assets/pdf/iqac/aqar-2023-24.pdf" target="_blank" class="download-btn">
          <i class="fa fa-download"></i> Download
        </a>
      </li>
      <li class="download-item">
        <span class="download-item-label">AQAR 2022–23</span>
        <span class="download-item-meta">2022-23</span>
        <a href="/assets/pdf/iqac/aqar-2022-23.pdf" target="_blank" class="download-btn">
          <i class="fa fa-download"></i> Download
        </a>
      </li>
      <li class="download-item">
        <span class="download-item-label">AQAR 2021–22</span>
        <span class="download-item-meta">2021-22</span>
        <a href="/assets/pdf/iqac/aqar-2021-22.pdf" target="_blank" class="download-btn">
          <i class="fa fa-download"></i> Download
        </a>
      </li>
    </ul>
  </div>
</div>